// extracted by css-extract-rspack-plugin
export default {"button":"FlagCell_button__tzhIU","show":"FlagCell_show__jFJrk"};